module.exports = __webpack_public_path__ + "img/img (5).2def9a1a.jpg";